import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/success.svg'
import _imports_1 from '@/assets/img/fail.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-332ad074")

_pushScopeId("data-v-332ad074")
const _hoisted_1 = { class: "_clickBlocker" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1
}
const _hoisted_4 = { class: "errore fs_24 fw_700" }
const _hoisted_5 = { class: "message" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "genericModalContent text-center",
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent","stop"]))
    }, [
      (!_ctx.isError)
        ? (_openBlock(), _createBlock("img", _hoisted_2))
        : (_openBlock(), _createBlock("img", _hoisted_3)),
      _createVNode("span", _hoisted_4, [
        (!_ctx.isError)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              localizedKey: 'app_successo',
              text: 'Successo'
            }))
          : (_openBlock(), _createBlock(_component_localized_text, {
              key: 1,
              localizedKey: 'app_errore',
              text: 'Errore'
            }))
      ]),
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.message), 1),
      _createVNode("button", {
        class: "genericButton bgWhite mt-4",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo(_ctx.buttonUrl)))
      }, _toDisplayString(_ctx.buttonText), 1)
    ])
  ]))
})